//-----------------------------------------------------------------------
//
// 共用字串定義。
//

//-----------------------------------------------------------------------
import { API_RESULT_CODE } from "./defines";

/** API 返回結果訊息。 */
export let messages : { [ key: number ] : string } = {};

messages[API_RESULT_CODE.Succeeded]						= "成功。";
messages[API_RESULT_CODE.Failed]						= "失敗。";
messages[API_RESULT_CODE.ServerOffline]					= "伺服器離線中。";
messages[API_RESULT_CODE.ParameterMissing]				= "缺少必須參數。";
messages[API_RESULT_CODE.NotConnected]					= "尚未連線。";
messages[API_RESULT_CODE.AccessDenied]					= "存取被拒。";
messages[API_RESULT_CODE.InvalidEmail]					= "e-mail 不合規格。";
messages[API_RESULT_CODE.InvalidPhoneNumber]			= "手機號碼不合規格。";
messages[API_RESULT_CODE.InvalidPassword]				= "密碼設定不合規格。";
messages[API_RESULT_CODE.InvalidParameter]				= "參數輸入內容不合規格。";
messages[API_RESULT_CODE.NetworkError]					= "網路錯誤。";
messages[API_RESULT_CODE.ServiceNotAvailableYet]		= "服務還不可使用，通常為有使用時間間隔限制的 API。";
messages[API_RESULT_CODE.MemberAlreadyCreated]			= "管理員帳號已建立。";
messages[API_RESULT_CODE.MemberCreateFailed]			= "無法建立新管理員。";
messages[API_RESULT_CODE.MemberNotExists]				= "管理員帳號不存在。";
messages[API_RESULT_CODE.MemberNotEnabled]				= "管理員帳號失效。";
messages[API_RESULT_CODE.MemberLoginFailed]				= "登入失敗。";
messages[API_RESULT_CODE.MemberNotLoggedIn]				= "尚未登入。";
messages[API_RESULT_CODE.MemberEmailAlreadyUsed]		= "管理員 email 已被使用中。";
messages[API_RESULT_CODE.MemberGroupNotAllowed]			= "管理員群組不可使用。";
messages[API_RESULT_CODE.MemberPermissionNotAllowed]	= "管理員權限不可使用。";
messages[API_RESULT_CODE.SourceAlreadyCreated]			= "資料來源已建立。";
messages[API_RESULT_CODE.SourceCreateFailed]			= "無法建立新資料來源。";
messages[API_RESULT_CODE.SourceNotExists]				= "資料來源不存在。";
messages[API_RESULT_CODE.SourceUrlAlreadyUsed]			= "資料來源 url 已有其他來源使用。";
messages[API_RESULT_CODE.RegionNotExists]				= "區域不存在。";
messages[API_RESULT_CODE.KeywordAlreadyCreated]			= "關鍵字已建立。";
messages[API_RESULT_CODE.KeywordCreateFailed]			= "無法建立新關鍵字。";
messages[API_RESULT_CODE.KeywordNotExists]				= "關鍵字不存在。";
messages[API_RESULT_CODE.KeywordTextAlreadyUsed]		= "關鍵字內容已被使用。";
messages[API_RESULT_CODE.ManuallyChannelAlreadyCreated]	= "手動新增頻道已建立。";
messages[API_RESULT_CODE.ManuallyChannelCreateFailed]	= "無法建立新手動新增頻道。";
messages[API_RESULT_CODE.ManuallyChannelNotExists]		= "手動新增頻道不存在。";
messages[API_RESULT_CODE.ManuallyChannelAlreadyUsed]	= "手動新增頻道已建立過。";
messages[API_RESULT_CODE.ScheduleTaskCreateFailed]		= "無法建立排程工作。";
messages[API_RESULT_CODE.ScheduleTaskNotExists]			= "排程工作不存在。";
messages[API_RESULT_CODE.ScheduleTaskAlreadyUsed]		= "排程工作已建立過。";
messages[API_RESULT_CODE.KolAlreadyCreated]				= "KOL 已建立。";
messages[API_RESULT_CODE.KolCreateFailed]				= "無法建立新 KOL。";
messages[API_RESULT_CODE.KolNotExists]					= "KOL 不存在。";
messages[API_RESULT_CODE.KolNameAlreadyUsed]			= "KOL 名稱已被使用。";
messages[API_RESULT_CODE.ChannelNotExists]				= "頻道不存在。";
messages[API_RESULT_CODE.TargetNotExists]				= "目標不存在。";
